import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-3 cursor-pointer"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-blue-500 to-green-500 rounded-lg">
              <i className="ri-heart-pulse-line text-white text-xl"></i>
            </div>
            <span className="text-xl font-bold text-gray-900">Liver Health Check</span>
          </button>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-8">プライバシーポリシー</h1>

          <div className="bg-white rounded-2xl p-8 shadow-lg space-y-8">
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">個人情報の取得について</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                MKメディカルパートナーズ（以下「当事業者」といいます）は、本サービスにおいて、氏名・住所・生年月日などの個人を特定する情報は取得いたしません。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">取得する情報</h2>
              <div className="space-y-3 text-sm text-gray-700 leading-relaxed">
                <p>当事業者は、以下の情報を取得する場合があります。</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>年齢、性別、体重などの基本情報（匿名）</li>
                  <li>血液検査データ（AST、ALT、血小板数など）</li>
                  <li>アクセスログ、Cookie情報</li>
                  <li>お問い合わせ時のメールアドレス</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">情報の利用目的</h2>
              <div className="space-y-3 text-sm text-gray-700 leading-relaxed">
                <p>取得した情報は、以下の目的で利用します。</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>本サービスの提供・運営</li>
                  <li>サービスの改善・開発</li>
                  <li>統計データの作成（個人を特定できない形式）</li>
                  <li>お問い合わせへの対応</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">情報の第三者提供</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                当事業者は、法令に基づく場合を除き、取得した情報を第三者に提供することはありません。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">情報の管理</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                当事業者は、取得した情報について、適切な安全管理措置を講じます。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">Cookieについて</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                本サービスでは、サービスの利便性向上のためにCookieを使用する場合があります。Cookieの使用を希望されない場合は、ブラウザの設定で無効にすることができます。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">プライバシーポリシーの変更</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                当事業者は、必要に応じて本プライバシーポリシーを変更することができます。変更後のプライバシーポリシーは、本サービス上に掲載した時点で効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">お問い合わせ</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                本プライバシーポリシーに関するお問い合わせは、本サービスのお問い合わせフォームよりご連絡ください。
              </p>
            </section>

            <div className="pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600">制定日：2026年1月1日</p>
            </div>
          </div>

          <div className="mt-8 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
            >
              ← トップページへ戻る
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPage;